module.exports = __webpack_public_path__ + "img/cash-drawer.2d14ebc7.svg";